// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__UQxjn","left":"StickyBox_left__3bpUE","right":"StickyBox_right__vmEe5"};